import { proxy } from 'valtio';
import { StepIndexerState } from 'hooks/useStepIndexer';

export const createOnlineWebinarStepIndexer = proxy<StepIndexerState>({
  stepIndex: 0,
  previousStep: 0,
});
